import { Injectable } from '@angular/core';
import { HttpClient, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';

import { PaymentItem } from './payment-item.model';
import { AbstractEntityService } from '../../shared/service/abstract-entity.service';

@Injectable()
export class PaymentItemService extends AbstractEntityService {

    protected resourceUrl = 'api/payment-items';
    private resourceSearchUrl = 'api/_search/payment-items';
    protected resourceCountUrl = 'api/_search/count/payment-items';

    constructor(protected http: HttpClient) { super(http); }

    create(paymentItem: PaymentItem): Observable<PaymentItem> {
        let copy: PaymentItem = Object.assign({}, paymentItem);
        return this.http.post<PaymentItem>(this.resourceUrl, copy).map((res: PaymentItem) => {
            return res;
        });
    }

    update(paymentItem: PaymentItem): Observable<PaymentItem> {
        let copy: PaymentItem = Object.assign({}, paymentItem);
        return this.http.put<PaymentItem>(this.resourceUrl, copy).map((res: PaymentItem) => {
            return res;
        });
    }

    find(id: number): Observable<PaymentItem> {
        return this.http.get<PaymentItem>(`${this.resourceUrl}/${id}`).map((res: PaymentItem) => {
            return res;
        });
    }

    query(req?: any): Observable<HttpResponse<PaymentItem[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<PaymentItem[]>>(this.resourceUrl, options)
            ;
    }

    search(req?: any): Observable<HttpResponse<PaymentItem[]>> {
        let options = this.createRequestOption(req);
        return this.http.get<HttpResponse<PaymentItem[]>>(this.resourceSearchUrl, options)
            ;
    }

}



// WEBPACK FOOTER //
// ./src/main/webapp/app/entities/payment-item/payment-item.service.ts